import axios from "axios";
const { REACT_APP_GET_EXERCICE_EN_COURS_URL} = process.env;

export class ExerciceService {
    getExerciceEnCours() {
        axios.get(REACT_APP_GET_EXERCICE_EN_COURS_URL).then((res) => {
                 localStorage.setItem('exerciceEnCours', res.data);
              });
    }
}
